import Content from "./index";

// eslint-disable-next-line no-shadow
export enum Columns {
	ALLOWED = "allowed",
	NAME = "name",
	PROVIDER = "provider",
	BRANCHES = "branches",
	SERVICE_ID = "serviceId",
}

export const columns: Content.ColumnType[] = [
	{ id: Columns.ALLOWED, label: "Allowed", width: 90 },
	{ id: Columns.NAME, label: "Name", width: 320 },
	{ id: Columns.PROVIDER, label: "Payment System Type", width: 220 },
	{ id: Columns.SERVICE_ID, label: "ServiceId", width: 160 },
	{ id: Columns.BRANCHES, label: "Branches" },
];

export const defaultColumnsId = columns.map(({ id }) => id);
